<template>
	<div class="mainContainer">
		<mainMap></mainMap>
		<div class="legend">
			<div><span class="legendCircle online"></span>在线电梯</div>
			<div><span class="legendCircle offline"></span>离线电梯</div>
		</div>
		<div class="elvDistrictNum" v-if="!districtLevel">
			<div class="elvNum">
				<div>省数量</div>
				<div class="numFont">{{elvDistrictNum.province||0}}</div>
			</div>
			<div class="elvNum">
				<div>市数量</div>
				<div class="numFont">{{elvDistrictNum.city||0}}</div>
			</div>
			<div class="elvNum">
				<div>区县数量</div>
				<div class="numFont">{{elvDistrictNum.area||0}}</div>
			</div>
			<div class="elvNum">
				<div>小区数量</div>
				<div class="numFont">{{elvDistrictNum.community||0}}</div>
			</div>
		</div>
	</div>
</template>

<script>
import mainMap from "./map.vue";
export default {
	components: { mainMap },
	data() {
		return {
			elvDistrictNum: {},
			districtData: {},
		}
	},
	computed: {
		districtLevel() {
			return this.districtData ? this.districtData.province : null
		}
	},
	methods: {
		getElvDistrictNum() {
			this.$api.nationalMap(this.districtData).then(res => {
				if (res.errorCode == 0) {
					this.elvDistrictNum = res.data
				}
			})
		}
	},
	created() {
		this.getElvDistrictNum();
		window.addEventListener("setItem", () => {
			this.districtData = sessionStorage.getItem("district") ?
				JSON.parse(sessionStorage.getItem("district")) : {};
			if (!this.districtData.province) {
				this.getElvDistrictNum();
			}
		});
	}
}
</script>


<style lang="scss" scoped>
.mainContainer {
	width: 100%;
	height: 100%;
	position: relative;
	.legend {
		position: absolute;
		left: 50px;
		bottom: 120px;
		width: 160px;
		height: 60px;
		font-size: 12px;
		background: url('../assets/bindBgc.png') no-repeat;
		background-size: 100% 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		padding: 10px 10px 10px 15px;
		color: #abc4d9;
		.legendCircle {
			display: inline-block;
			width: 8px;
			height: 8px;
			border-radius: 50%;
			margin-right: 15px;
		}
		.online {
			background-color: #ff6b00;
		}
		.offline {
			background-color: #00bcff;
		}
	}
	.elvDistrictNum {
		width: 100%;
		display: flex;
		justify-content: space-between;
		position: absolute;
		bottom: 20px;
		left: 0;
		padding: 0 50px;
		.elvNum {
			height: 70px;
			width: 160px;
			background: url('../assets/kuangBg.png') no-repeat;
			background-size: 100% 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			font-size: 14px;
			.numFont {
				font-size: 24px;
			}
		}
	}
}
</style>